// The note shown under the SENDER's own chat message when the server masked
// contact details out of it (owner, 2026-10-14, stage 1 of chat protection).
//
// messages.contact_masked is set by the mask_chat_contact trigger
// (migration 20261014163345): 0 nothing masked, 1 first time, 2 repeat.
// The trader and the supplier read different copy on purpose — a trader is
// advised, a supplier is told the rule — and a first offence gets the soft
// line, a repeat the warning the owner approved. The other side of the
// conversation sees only "[•••]" in place of the number; this note is never
// shown to them.
//
// Mirror of the app's src/lib/contactMaskNote.js — keep the two identical.

const NOTES = {
  supplier: {
    1: {
      ar: 'أخفينا بيانات التواصل من رسالتك. في معبر يكون التواصل داخل المنصة لحماية الطرفين، والدفع عبر معبر مضمون لك.',
      en: 'We hid the contact details in your message. On Maabar, all communication stays on the platform to protect both sides — and payment through Maabar is guaranteed for you.',
      zh: '我们已隐藏您消息中的联系方式。在 Maabar 上，所有沟通都在平台内进行，以保护双方权益；通过 Maabar 收款，您的货款有保障。',
    },
    2: {
      ar: 'تحذير من معبر: يُمنع طلب التواصل أو تحويل التعاملات خارج منصة معبر. تكرار هذه المخالفة قد يؤدي إلى تعليق حسابك أو حظره نهائيًا. الدفع عبر معبر مضمون لك، وخارجه لا نستطيع حمايتك.',
      en: 'Maabar warning: requesting contact details or moving business outside Maabar is not allowed. Repeated violations may lead to your account being suspended or permanently banned. Payment through Maabar is guaranteed for you — outside it, we cannot protect you.',
      zh: 'Maabar 警告：禁止索要联系方式或将交易转移到 Maabar 平台之外。多次违规可能导致您的账户被暂停或永久封禁。通过 Maabar 收款有保障，平台之外我们无法保护您。',
    },
  },
  buyer: {
    1: {
      ar: 'أخفينا بيانات التواصل من رسالتك. حفاظًا على حقوقك، ننصحك بإبقاء جميع المحادثات والاتفاقيات داخل منصة معبر.',
      en: 'We hid the contact details in your message. To protect your rights, keep all conversations and agreements on Maabar.',
      zh: '我们已隐藏您消息中的联系方式。为保障您的权益，请将所有沟通和协议保留在 Maabar 平台内。',
    },
    2: {
      ar: 'تنبيه من معبر: حفاظًا على حقوقك، ننصحك بإبقاء جميع المحادثات والاتفاقيات داخل منصة معبر. معبر غير مسؤول عن التعاملات أو الاتفاقيات التي تتم خارج المنصة.',
      en: 'Maabar notice: to protect your rights, keep all conversations and agreements on Maabar. Maabar is not responsible for dealings or agreements made outside the platform.',
      zh: 'Maabar 提醒：为保障您的权益，请将所有沟通和协议保留在 Maabar 平台内。Maabar 不对平台外的交易或协议负责。',
    },
  },
};

// role: the SENDER's profile role. Anything but 'supplier' reads the trader copy.
// level: messages.contact_masked. Returns '' when there is nothing to say.
export function contactMaskNote(role, level, lang = 'ar') {
  const n = Number(level) || 0;
  if (n <= 0) return '';
  const side = String(role || '').toLowerCase() === 'supplier' ? 'supplier' : 'buyer';
  const byLang = NOTES[side][n >= 2 ? 2 : 1];
  return byLang[lang] || byLang.ar;
}
